<div class="EFProduct {{ oneColumn ? 'EFProduct--OneColumn' : '' }}">
    @if(hasBack || hasClose) {
        <div class="container EFProduct-GoBack mt-3">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex">
                        <div>
                            @if(hasClose) {
                                <button type="button" class="btn btn-light me-3 shadow-sm" (click)="doClose.emit()" [attr.aria-label]="'experience-finder.a11y.close' | locTranslate">
                                    <i class="fa-regular fa-times" aria-hidden="true"></i>
                                </button>
                            }
                            @if(hasBack) {
                                <button type="button" class="btn btn-light me-3 shadow-sm" (click)="goBack.emit()" [attr.aria-label]="'experience-finder.a11y.back' | locTranslate">
                                    <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                        <div>
                            <app-pg-share buttonClass="btn-light shadow-sm" [shareTitle]="productData?.getTranslatedProductField('title')"></app-pg-share>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
        
    @if (productData && productData.error) {
        <div class="card-body text-center">
            <div class="alert alert-danger" role="alert">
                <div class="mb-3">
                    <i class="fa-regular fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
                </div>
                <div>
                    {{ 'experience-finder.general.product-error' | locTranslate }}
                </div>
            </div>
        </div>
    }

    @if (productData && !productData.error) {
        <div class="container EFProduct-Main pt-3">
            <div class="row">
                @if(hasBack || hasClose) {
                    <div class="col-12 position-relative opacity-00">
                        <div class="EFProduct-Images card">
                        </div>
                    </div>
                }

                @if (productData.embed; as embedList) {
                    @for (embed of embedList; track embed) {
                        @if (embed.ratio) {
                            @if (cleanEmbedSrc(embed.src); as src) {
                                <div class="col-12 position-relative">
                                    <div class="EFProduct-Embed EFProduct-Embed--Ratio-{{ embed.ratio.toUpperCase().replace(':', '_') }} card">
                                        <!-- NB: For security reasons, the `allowfullscreen` can be set on an <iframe> as a static attribute only. -->
                                        @if (!embed.fullscreen) {
                                            <iframe [src]="src | safe:'resourceUrl'"
                                                [attr.title]="'experience-finder.a11y.embed-content' | locTranslate"
                                                width="{{ embed.ratio == 'specify' ? embed.width : null }}" height="{{ embed.ratio == 'specify' ? embed.height : null }}">
                                            </iframe>
                                        }
                                        @if (embed.fullscreen) {
                                            <iframe [src]="src | safe:'resourceUrl'" allowfullscreen
                                                [attr.title]="'experience-finder.a11y.embed-content' | locTranslate"
                                                width="{{ embed.ratio == 'specify' ? embed.width : null }}" height="{{ embed.ratio == 'specify' ? embed.height : null }}">
                                            </iframe>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    }
                }
                @if ((videoList != null && videoList.length > 0)) {
                    <div class="col-12 position-relative">
                        <div class="EFProduct-Images card">
                            @if (videoList != null && videoList.length > 0) {
                                <app-ef-carousel [mediaList]="videoList"></app-ef-carousel>
                            }
                        </div>
                    </div>
                }
                @if ((imageList != null && imageList.length > 0)) {
                    <div class="col-12 position-relative">
                        <div class="EFProduct-Images card">
                            @if (imageList != null && imageList.length > 0) {
                                <app-ef-carousel [mediaList]="imageList"></app-ef-carousel>
                            }
                        </div>
                    </div>
                }
                <div class="col-12">
                    <div class="EFProduct-Translate small">
                        @if (productData.isCurrentTranslationAutomatic()) {
                            <div class="d-flex justify-content-end align-items-center">
                                <span>{{ 'experience-finder.ef-product.button-translation-automatic' | locTranslate }}</span>
                                <button class="btn btn-link btn-sm p-0 ms-1" (click)="productData.forceNonAutomaticTranslation()">{{ 'experience-finder.ef-product.button-unautomatic' | locTranslate }}</button>
                            </div>
                        }
                        @if (productData.isCurrentTranslationForced()) {
                            <div class="d-flex justify-content-end align-items-center">
                                <span>{{ 'experience-finder.ef-product.button-translation-forced' | locTranslate }}</span>
                                <button class="btn btn-link btn-sm p-0 ms-1" (click)="productData.unForceTranslation()">{{ 'experience-finder.ef-product.button-unforce' | locTranslate }}</button>
                            </div>
                        }
                        <!--<ng-container *ngIf="!productData.hasProductCurrentLanguage()">
                            <button *ngIf="productData.getRemoteTranslationStatus() != 'complete'" class="btn btn-sm btn-link bg-white" [disabled]="productData.getRemoteTranslationStatus() == 'loading'" (click)="productData.remoteTranslateProduct()">{{ 'experience-finder.ef-product.button-translate' | locTranslate }}</button>
                            <button *ngIf="productData.getRemoteTranslationStatus() == 'complete'" class="btn btn-sm btn-link bg-white" (click)="productData.unRemoteTranslateProduct()">{{ 'experience-finder.ef-product.button-untranslate' | locTranslate }}</button>
                        </ng-container>-->
                </div>
            </div>
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="EFProduct-Category mb-3 d-flex h5">
                            <div class="badge text-white" [style.backgroundColor]="getTypeColor(productData.type)">
                                <i class="fa-regular" [innerHTML]="getTypeIcon(productData.type)"></i>
                                <span class="ms-2">{{productData.getTypeText()}}</span>
                            </div>
                            @if (productData.getCategoryText(); as text) {
                                <div class="badge bg-white border ms-3" [style.color]="getTypeColor(productData.type)" [style.borderColor]="getTypeColor(productData.type) + ' !important'">
                                    <span [innerHTML]="text"></span>
                                </div>
                            }
                        </div>

                        <h3 [innerHTML]="productData.getTranslatedProductField('title')"></h3>

                        @if(productData.tagImages.length > 0) {
                            <div class="EFProduct-TagImages mb-2">
                                @for(tagImage of productData.tagImages; track tagImage) {
                                    <app-pg-tag-image [tag]="tagImage.tag" [image]="tagImage.image" [color]="getTypeColor(productData.type)"></app-pg-tag-image>
                                }
                            </div>
                        }

                        @if (getTagsDisplay(productData.tags); as tags) {
                            <div class="EFProduct-Tags">
                                <i class="fa-regular fa-hashtag"></i>
                                <b>{{ 'experience-finder.app.product-tags' | locTranslate }}:</b>
                                <span>{{ tags }}</span>
                            </div>
                        }

                        @if (productData.getTranslatedProductField('short_description'); as description) {
                            <div class="EFProduct-Description mb-3" [innerHTML]="description | safe:'html'" appExternalLinks></div>
                        }

                        @if (productData.getTranslatedProductField('description'); as description) {
                            <div class="EFProduct-Description mb-3" [innerHTML]="description | safe:'html'" appExternalLinks></div>
                        }
                        @for (additional_description of ['whats_included','services_description','special_dishes']; track additional_description) {
                            @if (productData.getTranslatedProductField(additional_description); as description) {
                                <h5 class="mb-3">{{ getAdditionalDescriptionLabel(additional_description) }}</h5>
                                <div class="EFProduct-Description mb-3" [innerHTML]="description | safe:'html'" appExternalLinks></div>
                            }
                        }
                        @if (productData.type != 'itinerary' && productData.type != 'good') {
                            <div class="EFProduct-Location mb-3">
                                <div class="EFProduct-Location-Map mb-3">
                                    <app-ef-product-map [productData]="POIData || productData" [disabled]="true"></app-ef-product-map>
                                </div>
                                <app-ef-product-location [productData]="productData" [POIData]="POIData"></app-ef-product-location>
                            </div>
                        }
                        @if (productData.phone != null || productData.landline_number != null || productData.email != null || productData.website != null || productData.contact != null) {
                            <div class="mb-3">
                                <h5 class="mb-3">{{ 'experience-finder.app.product-contacts' | locTranslate }}</h5>
                                @if (productData.phone != null || productData.landline_number != null) {
                                    <div class="EFProduct-Contact">
                                        <span class="EFProduct-Supplier-Contact-Label">
                                            {{ 'experience-finder.app.product-contacts-phone' | locTranslate }}
                                        </span>
                                        @for (prop of ['phone','landline_number']; track prop) {
                                            @if (productData[prop]; as phone) {
                                                @if (!useContactsQR) {
                                                    <a href="tel:{{phone}}">{{phone}}</a>
                                                }
                                                @if (useContactsQR) {
                                                    <a href="javascript:void(0)" (click)="openExternalLink('tel:' + phone)">{{phone}}</a>
                                                }
                                            }
                                        }
                                    </div>
                                }
                                @if (productData.email != null) {
                                    <div class="EFProduct-Contact">
                                        <span class="EFProduct-Supplier-Contact-Label">
                                            {{ 'experience-finder.app.product-contacts-email' | locTranslate }}
                                        </span>
                                        @if (!useContactsQR) {
                                            <a href="mailto:{{productData.email}}">{{productData.email}}</a>
                                        }
                                        @if (useContactsQR) {
                                            <a href="javascript:void(0)" (click)="openExternalLink('mailto:' + productData.email)">{{productData.email}}</a>
                                        }
                                    </div>
                                }
                                @if (productData.website != null) {
                                    <div class="EFProduct-Contact">
                                        <span class="EFProduct-Supplier-Contact-Label">
                                            {{ 'experience-finder.app.product-contacts-website' | locTranslate }}
                                        </span>
                                        @if (!useContactsQR) {
                                            <a target="_blank" href="{{productData.website}}">{{productData.website}}</a>
                                        }
                                        @if (useContactsQR) {
                                            <a href="javascript:void(0)" (click)="openExternalLink(productData.website)">{{productData.website}}</a>
                                        }
                                    </div>
                                }
                                @if (productData.contact != null) {
                                    <div [innerHTML]="productData.contact | safe:'html'"></div>
                                }
                            </div>
                        }
                        <div class="EFProduct-Classification">
                            @if (productData.getDateDisplay(); as date) {
                                <div>
                                    <i class="fa-regular fa-calendar"></i>
                                    <span>{{ 'experience-finder.app.product-date' | locTranslate }}</span>
                                    <b [innerHTML]="date | safe:'html'"></b>
                                </div>
                            }
                            @if (productData.getTimeDisplay(); as time) {
                                <div>
                                    <i class="fa-regular fa-clock"></i>
                                    <span>{{ 'experience-finder.app.product-time' | locTranslate }}</span>
                                    <b [innerHTML]="time | safe:'html'"></b>
                                </div>
                            }
                            @if (productData.stars; as stars) {
                                <div class="EFProduct-Classification-Stars">
                                    <i class="fa-regular fa-star"></i>
                                    <span>{{ 'experience-finder.app.product-stars' | locTranslate }}</span>
                                    <b>
                                        <small>
                                            @for (i of [1,2,3,4,5]; track i) {
                                                @if (i <= stars) {
                                                    <i class="fa-solid fa-star"></i>
                                                }
                                                @if (i > stars) {
                                                    <i class="fa-regular fa-star"></i>
                                                }
                                            }
                                        </small>
                                    </b>
                                </div>
                            }
                            @if (getOptionMappedArrayStringDisplay(productData.cuisine_type, productData.resource, 'cuisine_type'); as cuisine_type) {
                                <div>
                                    <i class="fa-regular fa-hat-chef"></i>
                                    <span>{{ 'experience-finder.app.product-cuisine_type' | locTranslate }}</span>
                                    <b>{{cuisine_type}}</b>
                                </div>
                            }
                            @if (productData.duration; as duration) {
                                <div>
                                    <i class="fa-regular fa-stopwatch"></i>
                                    <span>{{ 'experience-finder.app.product-duration' | locTranslate }}</span>
                                    <b>{{duration | locFormat:'duration'}}</b>
                                </div>
                            }
                            @if (getOptionMappedArrayStringDisplay(productData.target, productData.resource, 'target'); as target) {
                                <div>
                                    <i class="fa-regular fa-users"></i>
                                    <span>{{ 'experience-finder.app.product-target' | locTranslate }}</span>
                                    <b>{{target}}</b>
                                </div>
                            }
                            @if (getLanguagesDisplay(productData.languages); as languages) {
                                <div>
                                    <i class="fa-regular fa-globe"></i>
                                    <span>{{ 'experience-finder.app.product-languages' | locTranslate }}</span>
                                    <b [innerHTML]="languages | safe:'html'"></b>
                                </div>
                            }
                            @if (productData.mean_of_transport; as transport) {
                                <div>
                                    <i class="fa-regular fa-walking"></i>
                                    <span>{{ 'experience-finder.app.product-mean_of_transport' | locTranslate }}</span>
                                    <b>
                                        @for (item of transport; track item; let i = $index) {
                                            @if (i > 0) {
                                                ,
                                                } {{ 'OPTIONMAPS.Itinerary.mean_of_transport.' + item | locTranslate }}
                                            }
                                        </b>
                                    </div>
                                }
                                @if (productData.travel_distance; as travel_distance) {
                                    <div>
                                        <i class="fa-regular fa-road"></i>
                                        <span>{{ 'experience-finder.app.product-travel_distance' | locTranslate }}</span>
                                        <b>{{travel_distance | locFormat:'distance'}}</b>
                                    </div>
                                }
                                @if (!productData.duration) {
                                    @if (productData.travel_time; as travel_time) {
                                        <div>
                                            <i class="fa-regular fa-stopwatch"></i>
                                            <span>{{ 'experience-finder.app.product-travel_time' | locTranslate }}</span>
                                            <b>{{travel_time | locFormat:'duration'}}</b>
                                        </div>
                                    }
                                }
                                @if (hasAvailabilityDisplay()) {
                                    @if (productData.getDateDisplay(true); as availability) {
                                        <div class="EFProduct-Classification-Availability">
                                            <i class="fa-regular fa-circle-check"></i>
                                            <span>{{ 'experience-finder.app.product-availability' | locTranslate }}</span>
                                            <b>
                                                <span [innerHTML]="availability | safe:'html'"></span>
                                                @if (hasAvailabilityDetails(productData.availability)) {
                                                    <div class="EFProduct-Classification-Availability-Details">
                                                        <button class="btn btn-link p-0" (click)="openAvailabilityDetails(productData.availability)">{{ 'experience-finder.app.product-availability-hours' | locTranslate }}</button>
                                                    </div>
                                                }
                                            </b>
                                        </div>
                                    }
                                }
                            </div>
                            @if (productData.services != null) {
                                <div class="EFProduct-Services mt-3">
                                    @for (list of productData.services | keyvalue; track list) {
                                        @if (getServiceListDisplay(list.value, list.key); as serviceTypeDisplay) {
                                            <div class="mb-3">
                                                <h5 class="mb-1">{{ getServiceTypeLabel(list.key) }}</h5>
                                                <div>{{ serviceTypeDisplay }}</div>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                @if (productData.paragraphs != null) {
                    @for(paragraph of productData.paragraphs; track paragraph; let i = $index) {
                        <div class="col-12 EFProduct-Paragraph">
                            <div class="card">
                                @if (paragraph.images != null && paragraph.images.length > 0) {
                                    <div class="EFProduct-Paragraph-Images">
                                        <app-ef-carousel [mediaList]="paragraph.images | customFn:mapParagraphImageList"></app-ef-carousel>
                                    </div>
                                }

                                <div class="card-body">    
                                    @if(paragraph.title != null) {
                                        <h3 [innerHTML]="productData.getTranslatedProductFieldArrayProperty('paragraphs', i, 'title')"></h3>
                                    }

                                    @if(paragraph.tags != null) {
                                        <div class="EFProduct-Tags">
                                            <i class="fa-regular fa-hashtag"></i>
                                            <b>{{ 'experience-finder.app.product-tags' | locTranslate }}:</b>
                                            <span>{{ paragraph.tags }}</span>
                                        </div>
                                    }
                                    
                                    @if(paragraph.text != null) {
                                        <div class="EFProduct-Paragraph-Text" [innerHTML]="productData.getTranslatedProductFieldArrayProperty('paragraphs', i, 'text') | safe:'html'"></div>
                                    }

                                    @if(paragraph.links != null && paragraph.links.length > 0) {
                                        <div class="EFProduct-Paragraph-Links mt-3">
                                            @for(link of paragraph.links; track link) {
                                                <a target="_blank" href="{{ link.url }}" class="me-3">
                                                    <i class="fa-regular fa-up-right-from-square me-2"></i>
                                                    <span>{{ link.name }}</span>
                                                </a>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                    }
                }

                @if (productData.hasAccessibility()) {
                    <div class="col-12 EFProduct-Accessibility-Container">
                        <div class="card EFProduct-Accessibility">
                            <div class="card-body">
                                <h4 class="mb-3">{{ 'experience-finder.ef-product.accessibility' | locTranslate }}</h4>
                                @for (accessibilityType of ['physical_accessibility','cognitive_accessibility','blindness_accessibility','deafness_accessibility']; track accessibilityType) {
                                    @if (productData[accessibilityType] != null) {
                                        <div class="mb-3">
                                            <h5 class="EFProduct-Accessibility-Type mb-0">{{ 'experience-finder.ef-product.' + accessibilityType | locTranslate }}</h5>
                                            <div class="EFProduct-Accessibility-Value mt-1">
                                                <span class="ms-2 float-end">
                                                    @for (val of [1,2,3]; track val) {
                                                        <i class="fa-{{ val > productData[accessibilityType] ? 'regular' : 'solid' }} fa-star"></i>
                                                    }
                                                </span>
                                                <span>{{ getAccessibilityText(accessibilityType, productData[accessibilityType]) }}</span>
                                            </div>
                                            <div class="EFProduct-Accessibility-Tooltip small mt-1">{{ getAccessibilityTooltip(accessibilityType, productData[accessibilityType]) }}</div>
                                        </div>
                                    }
                                }
                                @if (productData.getTranslatedProductField('accessibility_description'); as description) {
                                    <div class="mb-3">
                                        <span [innerHTML]="description"></span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                @if (productData.hasPrice()) {
                    <div class="col-12 EFProduct-Buy-Container">
                        <div class="card EFProduct-Buy">
                            <div class="card-body">
                                @if (productData.accommodations != null) {
                                    <div class="col-12">
                                        <h4 class="mb-3">{{ 'experience-finder.ef-product.cost' | locTranslate }}</h4>
                                        @for (accommodation of productData.accommodations; track accommodation; let i = $index) {
                                            <div class="mb-3 EFProduct-Accommodation">
                                                <h5 class="mb-1" [innerHTML]="productData.getTranslatedProductFieldArrayProperty('accommodations', i, 'accommodation_description')"></h5>
                                                @if (accommodation.accommodation_room_services != null) {
                                                    <div class="EFProduct-Services">
                                                        <span>{{getOptionMappedArrayStringDisplay(accommodation.accommodation_room_services, 'Host', 'room_services')}}</span>
                                                    </div>
                                                }
                                                @if (accommodation.accommodation_appartaments_services != null) {
                                                    <div class="EFProduct-Services">
                                                        <span>{{getOptionMappedArrayStringDisplay(accommodation.accommodation_appartaments_services, 'Host', 'appartaments_services')}}</span>
                                                    </div>
                                                }
                                                @if (getCostStartingAtDisplay(accommodation.cost_range); as cost_starting) {
                                                    <div class="EFProduct-Buy-Price">
                                                        <div>
                                                            @if (isCostStartingAt(accommodation.cost_range)) {
                                                                <div class="pe-2">{{ 'experience-finder.ef-product.cost-starting-from' | locTranslate }}</div>
                                                            }
                                                        </div>
                                                        <div>
                                                            <h5 class="m-0 text-success" [innerHTML]="cost_starting | safe:'html'"></h5>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                @if (productData.accommodations == null) {
                                    @if (getCostStartingAtDisplay(productData.cost_list); as cost_starting) {
                                        <div class="d-flex justify-content-between">
                                            <h4 class="m-0">{{ 'experience-finder.ef-product.cost' | locTranslate }}</h4>
                                            <div class="EFProduct-Buy-Price">
                                                <div>
                                                    @if (isCostStartingAt(productData.cost_list)) {
                                                        <div class="pe-2">{{ 'experience-finder.ef-product.cost-starting-from' | locTranslate }}</div>
                                                    }
                                                </div>
                                                <div>
                                                    <h5 class="m-0 text-success" [innerHTML]="cost_starting | safe:'html'"></h5>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                                @if (productData.file_gpx; as fileList) {
                                    <div>
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <span class="me-2">{{ 'experience-finder.ef-product.file_gpx' | locTranslate }}</span>
                                            </div>
                                            <div>
                                                @for (file of fileList; track file) {
                                                    <a class="ms-1 btn-link" target="_blank" [href]="file | safe:'url'">
                                                        <i class="fa-regular fa-download"></i>
                                                    </a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (productData.hasMenu()) {
                                    <div>
                                        @if (productData.getMenuLink(); as menu) {
                                            <div>
                                                <a target="_blank" [href]="menu | safe:'url'">
                                                    <i class="fa-regular fa-book-open"></i>
                                                    <span class="me-2">{{ 'experience-finder.ef-product.menu-link' | locTranslate }}</span>
                                                </a>
                                            </div>
                                        }
                                        
                                        @if (productData.getMenuFiles(); as files) {
                                            @for (menu of files; track menu) {
                                                <div>
                                                    <a target="_blank" [href]="menu | safe:'url'">
                                                        <i class="fa-regular fa-book-open"></i>
                                                        <span class="me-2">{{ 'experience-finder.ef-product.menu-file' | locTranslate }}</span>
                                                    </a>
                                                </div>
                                            }
                                        }

                                        @if (productData.menu != null) {
                                            @for (item of productData.menu; track item; let i = $index) {
                                                <div class="EFProduct-MenuItem">
                                                    <div>
                                                        <h5 class="d-flex mb-1">
                                                            <span [innerHTML]="productData.getTranslatedProductFieldArrayProperty('menu', i, 'menu_name')"></span>
                                                            <span class="text-nowrap text-success">{{item.menu_price}} {{item.menu_price_unit}}</span>
                                                        </h5>
                                                        <div class="text-muted EFProduct-MenuItem-Description mb-1" [innerHTML]="productData.getTranslatedProductFieldArrayProperty('menu', i, 'menu_description')"></div>
                                                    </div>
                                                </div>
                                            }
                                        }
                                    </div>
                                }
                                @if (getCostRangeDisplay(productData.cost_range); as cost_range) {
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex justify-content-between">
                                            <h4 class="mb-3">{{ 'experience-finder.ef-product.cost-range' | locTranslate }}</h4>
                                            <div class="mb-3 EFProduct-Buy-Price">
                                                <h5 class="m-0" [innerHTML]="cost_range | safe:'html'"></h5>
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (getPaymentMethodDisplay(); as payment_method) {
                                    <div class="EFProduct-Buy-PaymentMethod text-success">{{ payment_method }}</div>
                                }
                                @if (productData.isBookable() && !disableBooking) {
                                    @if (getCheckoutURL(); as url) {
                                        <div class="mt-3">
                                            @if (useBookingQR) {
                                                <button class="btn btn-primary btn-block btn-lg mt-0" (click)="showBookingQR(url)">
                                                    {{ 'experience-finder.ef-product.button-book-now' | locTranslate }}
                                                </button>
                                            }
                                            @if (!useBookingQR) {
                                                <a class="btn btn-primary btn-block btn-lg mt-0" target="_blank" href="{{url}}">
                                                    {{ 'experience-finder.ef-product.button-book-now' | locTranslate }}
                                                </a>
                                            }
                                        </div>
                                    }
                                }
                                <!--<button class="btn btn-outline-primary btn-block btn-lg mt-0">{{ 'experience-finder.ef-product.button-add-calendar' | locTranslate }}</button>-->
                            </div>
                        </div>
                    </div>
                }
                
                @if (supplierData != null && !supplierData.error) {
                    <div class="col-12">
                        <div class="EFProduct-Supplier card">
                            <div class="card-body">
                                <div class="row">
                                    @if (supplierData.logo != null && supplierData.logo != '') {
                                        <div class="col-4">
                                            <img  class="EFProduct-Supplier-Image" [src]="supplierData.logo"/>
                                        </div>
                                    }
                                    <div class="{{ supplierData.logo != null && supplierData.logo != '' ? 'col-8' : 'col-12'}}">
                                        <h5 class="mb-3">{{supplierData.name}}</h5>
                                        @if (supplierData.phone != null) {
                                            <div class="EFProduct-Supplier-Contact">
                                                <span class="EFProduct-Supplier-Contact-Label">
                                                    {{ 'experience-finder.app.product-contacts-phone' | locTranslate }}
                                                </span>
                                                @if (!useContactsQR) {
                                                    <a href="tel:{{supplierData.phone}}">{{supplierData.phone}}</a>
                                                }
                                                @if (useContactsQR) {
                                                    <a href="javascript:void(0)" (click)="openExternalLink('tel:' + supplierData.phone)">{{supplierData.phone}}</a>
                                                }
                                                @if (!useContactsQR) {
                                                    <a href="tel:{{supplierData.landline_number}}">{{supplierData.landline_number}}</a>
                                                }
                                                @if (useContactsQR) {
                                                    <a href="javascript:void(0)" (click)="openExternalLink('tel:' + supplierData.landline_number)">{{supplierData.landline_number}}</a>
                                                }
                                            </div>
                                        }
                                        @if (supplierData.email != null) {
                                            <div class="EFProduct-Supplier-Contact">
                                                <span class="EFProduct-Supplier-Contact-Label">
                                                    {{ 'experience-finder.app.product-contacts-email' | locTranslate }}
                                                </span>
                                                @if (!useContactsQR) {
                                                    <a href="mailto:{{supplierData.email}}">{{supplierData.email}}</a>
                                                }
                                                @if (useContactsQR) {
                                                    <a href="javascript:void(0)" (click)="openExternalLink('mailto:' + supplierData.email)">{{supplierData.email}}</a>
                                                }
                                            </div>
                                        }
                                        @if (supplierData.website != null) {
                                            <div class="EFProduct-Supplier-Contact">
                                                <span class="EFProduct-Supplier-Contact-Label">
                                                    {{ 'experience-finder.app.product-contacts-website' | locTranslate }}
                                                </span>
                                                @if (!useContactsQR) {
                                                    <a target="_blank" href="{{supplierData.website}}">{{supplierData.website}}</a>
                                                }
                                                @if (useContactsQR) {
                                                    <a href="javascript:void(0)" (click)="openExternalLink('mailto:' + supplierData.website)">{{supplierData.website}}</a>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (productData.type == 'itinerary') {
                    <div class="col-12 EFProduct-Map {{itineraryHideMap() ? 'EFProduct-Map--Hidden' : ''}}">
                        <app-ef-product-map [hideMap]="itineraryHideMap()" [productData]="productData" [disabled]="true" (showStop)="onShowStop($event)"></app-ef-product-map>
                    </div>
                }
            </div>
            <!-- TODO: DA SISTEMARE, da qui in poi  -->
            <div class="row">
                @if (showcaseElements != null) {
                    <div class="col-12 EFProduct-Showcase mb-3">
                        <app-pg-showcase [showcaseElements]="showcaseElements"></app-pg-showcase>
                    </div>
                }
                @if (productData.hasParent()) {
                    <div class="col-12 EFProduct-Parent my-3">
                        <h5 class="mb-3">{{ 'experience-finder.ef-product.parent-' + productData.type | locTranslate }}</h5>
                        @if (isLoadingParent) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!isLoadingParent) {
                            <div>
                                <app-ef-product-card [productData]="parentProductData" (showProduct)="onShowProduct($event)"></app-ef-product-card>
                            </div>
                        }
                    </div>
                }
                @if (productData.canHaveChildren()) {
                    @if (isLoadingChildren) {
                        <app-pg-loading></app-pg-loading>
                    }
                    @if (!isLoadingChildren && childrenProductData != null && childrenProductData.length > 0) {
                        <div class="col-12 EFProduct-Children mt-3">
                            <h5 class="mb-0">{{ 'experience-finder.ef-product.children-' + productData.type | locTranslate }}</h5>
                            <div>
                                <app-ef-list [oneItem]="true" [productsData]="childrenProductData" (showProduct)="onShowProduct($event)"></app-ef-list>
                            </div>
                        </div>
                    }
                }
                @if (isLoadingGoods) {
                    <app-pg-loading></app-pg-loading>
                }
                @if (!isLoadingGoods && goodsProductData != null && goodsProductData.length > 0) {
                    <div class="col-12 EFProduct-Children mt-3">
                        <h5 class="mb-0">{{ 'experience-finder.ef-product.supplier-goods' | locTranslate }}</h5>
                        <div>
                            <app-ef-list [oneItem]="true" [productsData]="goodsProductData" (showProduct)="onShowProduct($event)"></app-ef-list>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>

<ng-template #modalAvailabilityDetails>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'experience-finder.app.product-availability' | locTranslate }}</h5>
        <button type="button" class="btn-close" [attr.aria-label]="'experience-finder.a11y.close' | locTranslate" (click)="closeAvailabilityDetails()"></button>
    </div>
    <div class="modal-body">
        @for (item of modalAvailabilityDetailsTarget; track item) {
            @if (isAvailabilityValid(item)) {
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th [attr.colspan]="7">
                                    @if (item.periods.length == 0) {
                                        <h6 class="m-0">{{ 'pg-timetable-editor.all-year' | locTranslate}}</h6>
                                    }
                                    @for (period of item.periods; track period; let i = $index) {
                                        <h6 class="m-0">
                                            @if (i > 0) {
                                                ,
                                            }
                                            @if (isAvailabilityPeriodAllYear(period)) {
                                                {{ 'pg-timetable-editor.all-year' | locTranslate }}
                                            }
                                            @if (!isAvailabilityPeriodAllYear(period)) {
                                                {{ getAvailabilityPeriodDates(period) }}
                                            }
                                        </h6>
                                    }
                                </th>
                            </tr>
                            <tr>
                                @for (i of [0,1,2,3,4,5,6]; track i) {
                                    <th class="text-center">
                                        {{getDayName(i)}}
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                @if (item.unavailable) {
                                    <td [attr.colspan]="7">
                                        <span class="text-danger">{{ 'pg-timetable-editor.unavailable-period' | locTranslate }}</span>
                                    </td>
                                }
                                @if (!item.unavailable) {
                                    @for (i of [0,1,2,3,4,5,6]; track i) {
                                        <td class="text-center pb-0">
                                            @for (hour of item.hours; track hour) {
                                                <div class="pb-2">
                                                    @if (getDayStatus(hour, i)) {
                                                        <div>{{ hour.begin }}@if (productData.getAvailabilityType() == 'timetable-openings') {
                                                            <br>{{ hour.end }}
                                                            }</div>
                                                        }
                                                        @if (!getDayStatus(hour, i)) {
                                                            <div>&nbsp;@if (productData.getAvailabilityType() == 'timetable-openings') {
                                                                <br>&nbsp;
                                                                }</div>
                                                            }
                                                        </div>
                                                    }
                                                </td>
                                            }
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                }
            </div>
        </ng-template>

        <ng-template #modalExternalLink>
            <div class="modal-header">
                <h5 class="modal-title">{{ 'experience-finder.ef-product.modal-external-link-title' | locTranslate }}</h5>
            </div>
            <div class="modal-body">
                <p class="text-center">{{ 'experience-finder.ef-product.modal-external-link-text' | locTranslate }}</p>
                <div>
                    <app-pg-qrcode [text]="modalExternalLinkTarget"></app-pg-qrcode>
                </div>
                <div class="text-center mt-3">
                    <button class="btn btn-primary" (click)="closeExternalLink()">{{ 'experience-finder.ef-product.modal-external-link-close' | locTranslate }}</button>
                </div>
            </div>
        </ng-template>

        <ng-template #modalBookingQR>
            <div class="modal-header">
                <h5 class="modal-title">{{ 'experience-finder.ef-product.modal-booking-qr-title' | locTranslate }}</h5>
            </div>
            <div class="modal-body">
                <p class="text-center">{{ 'experience-finder.ef-product.modal-booking-qr-text' | locTranslate }}</p>
                <div>
                    <app-pg-qrcode [text]="modalBookingQRTarget"></app-pg-qrcode>
                </div>
                <div class="text-center mt-3">
                    <button class="btn btn-primary" (click)="hideBookingQR()">{{ 'experience-finder.ef-product.modal-booking-qr-close' | locTranslate }}</button>
                </div>
            </div>
        </ng-template>

        <ng-template #modalShowStop>
            <div class="modal-header">
                <h5 class="modal-title">{{ 'experience-finder.ef-product.modal-show-stop-title' | locTranslate }}</h5>
                <button type="button" class="modal-close btn btn-link" (click)="hideShowStop()" [attr.aria-label]="'experience-finder.a11y.close' | locTranslate">
                    <i class="fa-regular fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <app-ef-itinerary-stop-card [singleDay]="productData.single_day" [stopData]="modalShowStopData" [disabled]="true" [full]="true" [appMode]="appMode"></app-ef-itinerary-stop-card>
                </div>
            </div>
        </ng-template>